<template>
  <div class="modal" id="passwordUpdateModal" tabindex="-1" aria-labelledby="passwordUpdateModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="passwordUpdateModalLabel">パスワード更新</h5>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submitNewPassword">
            <div class="mb-3">
              <label for="password">新しいパスワード:</label>
              <input type="password" id="password" class="form-control" v-model="password" required>
            </div>
            <div class="mb-3">
              <label for="passwordConfirmation">パスワード確認:</label>
              <input type="password" id="passwordConfirmation" class="form-control" v-model="passwordConfirmation" required>
            </div>
            <div class="btn-area">
              <button type="button" class="btn btn-secondary mx-1" data-bs-dismiss="modal">キャンセル</button>
              <button type="submit" class="btn btn-success mx-1">更新</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { passwordUpdate } from '@/api/axios';
import { Modal } from 'bootstrap';

export default {
  props: ['userId'], // ユーザーIDを props として受け取る

  setup(props) {
    const store = useStore();
    const password = ref('');
    const passwordConfirmation = ref('');
    const errorMessages = ref({});

    const close = () => {
      const modalElement = document.getElementById('passwordUpdateModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    const submitNewPassword = async () => {
      if (password.value !== passwordConfirmation.value) {
        alert("パスワードが一致しません。");
        return;
      }

      try {
        await passwordUpdate({
          user_id: props.userId, // ユーザーIDを使用
          password: password.value,
          password_confirmation: passwordConfirmation.value,
        });
        store.commit('setFlashMessage', {message: 'パスワードがリセットされました', type: 'success'});
        close();
        password.value = '';
        passwordConfirmation.value = '';
      } catch (error) {
        if (error.response && error.response.data) {
          errorMessages.value = error.response.data.errors || {};
        }
        store.commit('setFlashMessage', {message: 'パスワードリセットに失敗しました', type: 'danger'});
        console.error('パスワードリセットに失敗しました:', error);
      }
    };

    return {
      password,
      passwordConfirmation,
      close,
      submitNewPassword,
      errorMessages
    };
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-bottom: 5px;
}

.btn-area{
  margin-top: 24px;
  text-align: right;
}
</style>
